import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ForumPage = lazy(() => import('../pages/forum/page'));
const ForumHomePage = lazy(() => import('../pages/forum/home/page'));
const ForumNewPostPage = lazy(() => import('../pages/forum/new/page'));
const ForumPostPage = lazy(() => import('../pages/forum/post/page'));
const ForumCategoryPage = lazy(() => import('../pages/forum/category/page'));
const ForumLoginPage = lazy(() => import('../pages/forum/login/page'));
const ForumVerifyPage = lazy(() => import('../pages/forum/verify/page'));
const ForumEditPage = lazy(() => import('../pages/forum/edit/page'));
const ForumChatPage = lazy(() => import('../pages/forum/chat/page'));
const ForumNotificationsPage = lazy(() => import('../pages/forum/notifications/page'));
// 🔥 新增：攻略專區和額度商城
const ForumGuidesPage = lazy(() => import('../pages/forum/guides/page'));
const CreditsShopPage = lazy(() => import('../pages/forum/credits-shop/page'));
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const AdminApplicationsPage = lazy(() => import('../pages/admin/applications/page'));
const AdminBrandPage = lazy(() => import('../pages/admin/brand/page'));
const AdminContentPage = lazy(() => import('../pages/admin/content/page'));
const AdminSEOPage = lazy(() => import('../pages/admin/seo/page'));
const AdminPixelAnalyticsPage = lazy(() => import('../pages/admin/pixel-analytics/page'));
const AdminManagementPage = lazy(() => import('../pages/admin/admin-management/page'));
const AdminCommentsPage = lazy(() => import('../pages/admin/comments/page'));
const AdminPostsPage = lazy(() => import('../pages/admin/posts/page'));
const ForumManagementPage = lazy(() => import('../pages/admin/forum-management/page'));
const ForumAnalyticsPage = lazy(() => import('../pages/admin/forum-analytics/page'));
const ForumCategoriesPage = lazy(() => import('../pages/admin/forum-categories/page'));
const AIModerationPage = lazy(() => import('../pages/admin/ai-moderation/page'));
const ColdThreadsPage = lazy(() => import('../pages/admin/ai-ops/cold-threads/page'));
const DigestPage = lazy(() => import('../pages/admin/ai-ops/digest/page'));
const ChatModerationPage = lazy(() => import('../pages/admin/chat-moderation/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// 導入新頁面
const UserManagementPage = lazy(() => import('../pages/admin/user-management/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/forum',
    element: <ForumPage />,
  },
  {
    path: '/forum/home',
    element: <ForumHomePage />,
  },
  {
    path: '/forum/new',
    element: <ForumNewPostPage />,
  },
  {
    path: '/forum/post/:id',
    element: <ForumPostPage />,
  },
  {
    path: '/forum/t/:slug',
    element: <ForumPostPage />,
  },
  {
    path: '/forum/category/:slug',
    element: <ForumCategoryPage />,
  },
  {
    path: '/forum/c/:slug',
    element: <ForumCategoryPage />,
  },
  {
    path: '/forum/login',
    element: <ForumLoginPage />,
  },
  {
    path: '/forum/verify',
    element: <ForumVerifyPage />,
  },
  {
    path: '/forum/edit/:id',
    element: <ForumEditPage />,
  },
  {
    path: '/forum/chat',
    element: <ForumChatPage />,
  },
  {
    path: '/forum/notifications',
    element: <ForumNotificationsPage />,
  },
  // 🔥 新增：攻略專區路由
  {
    path: '/forum/guides',
    element: <ForumGuidesPage />,
  },
  // 🔥 新增：額度商城路由
  {
    path: '/forum/credits-shop',
    element: <CreditsShopPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboardPage />,
  },
  {
    path: '/admin/applications',
    element: <AdminApplicationsPage />,
  },
  {
    path: '/admin/brand',
    element: <AdminBrandPage />,
  },
  {
    path: '/admin/content',
    element: <AdminContentPage />,
  },
  {
    path: '/admin/seo',
    element: <AdminSEOPage />,
  },
  {
    path: '/admin/pixel-analytics',
    element: <AdminPixelAnalyticsPage />,
  },
  {
    path: '/admin/admin-management',
    element: <AdminManagementPage />,
  },
  {
    path: '/admin/comments',
    element: <AdminCommentsPage />,
  },
  {
    path: '/admin/posts',
    element: <AdminPostsPage />,
  },
  {
    path: '/admin/forum-management',
    element: <ForumManagementPage />,
  },
  {
    path: '/admin/user-management',
    element: <UserManagementPage />
  },
  {
    path: '/admin/vip-management',
    element: lazy(() => import('../pages/admin/vip-management/page'))
  },
  {
    path: '/admin/guide-review',
    element: lazy(() => import('../pages/admin/guide-review/page')),
  },
  {
    path: '/ray-admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/ray-admin/dashboard',
    element: <AdminDashboardPage />,
  },
  {
    path: '/ray-admin/applications',
    element: <AdminApplicationsPage />,
  },
  {
    path: '/ray-admin/brand',
    element: <AdminBrandPage />,
  },
  {
    path: '/ray-admin/content',
    element: <AdminContentPage />,
  },
  {
    path: '/ray-admin/seo',
    element: <AdminSEOPage />,
  },
  {
    path: '/ray-admin/pixel-analytics',
    element: <AdminPixelAnalyticsPage />,
  },
  {
    path: '/ray-admin/admin-management',
    element: <AdminManagementPage />,
  },
  {
    path: '/ray-admin/comments',
    element: <AdminCommentsPage />,
  },
  {
    path: '/ray-admin/posts',
    element: <AdminPostsPage />,
  },
  {
    path: '/ray-admin/forum-management',
    element: <ForumManagementPage />,
  },
  {
    path: '/ray-admin/ai-moderation',
    element: <AIModerationPage />,
  },
  {
    path: '/ray-admin/ai-ops/cold-threads',
    element: <ColdThreadsPage />,
  },
  {
    path: '/ray-admin/ai-ops/digest',
    element: <DigestPage />,
  },
  {
    path: '/ray-admin/chat-moderation',
    element: <ChatModerationPage />,
  },
  {
    path: '/ray-admin',
    children: [
      {
        path: 'forum-management',
        element: <ForumManagementPage />,
      },
      {
        path: 'forum-analytics',
        element: <ForumAnalyticsPage />,
      },
      {
        path: 'forum-categories',
        element: <ForumCategoriesPage />,
      },
      {
        path: 'admin-management',
        element: <AdminManagementPage />,
      },
      {
        path: 'user-management',
        element: <UserManagementPage />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
